import { render, staticRenderFns } from "./EntitySummary.vue?vue&type=template&id=68da09fc&scoped=true&lang=pug&"
import script from "./EntitySummary.vue?vue&type=script&lang=js&"
export * from "./EntitySummary.vue?vue&type=script&lang=js&"
import style0 from "./EntitySummary.vue?vue&type=style&index=0&id=68da09fc&lang=scss&scoped=true&"
import style1 from "./EntitySummary.vue?vue&type=style&index=1&id=68da09fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68da09fc",
  null
  
)

export default component.exports